import Vue from 'vue'
import VueI18n from 'vue-i18n'
import getBrowserLocale from "@/i18n/get-browser-locale";

Vue.use(VueI18n)

function loadLocaleMessages () {
    const locales = getLocales();
    const messages = {}
    locales.keys().forEach(key => {
        const matched = key.match(/([A-Za-z0-9-_]+)\./i)
        if (matched && matched.length > 1) {
            const locale = matched[1]
            messages[locale] = locales(key)
        }
    })
    return messages
}

function getStartingLocale() {
    const browserLocale = getBrowserLocale({ countryCodeOnly: true })
    let locales = getLocales();

    let retLocale = ''
    locales.keys().forEach(key => {
        if (key.includes(browserLocale)) {
            retLocale = browserLocale;
        }
    });
    if (retLocale !== '') return retLocale;

    console.log("Locale " + browserLocale + " not supported. Supported locales: " + locales.keys())
    return process.env.VUE_APP_I18N_LOCALE || "en"
}

function getLocales() {
    return require.context('./locales', true, /[A-Za-z0-9-_,\s]+\.json$/i);
}

export default new VueI18n({
    locale: getStartingLocale(),
    fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'de',
    messages: loadLocaleMessages()
})